import { request } from '@umijs/max';

export async function uploadFile(
  file: File,
  source: number,
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('source', String(source));

  try {
    const response = await request<API.BackendApiResponse<API.FileItem>>('/api/file/upload', {
      method: 'POST',
      data: formData,
      skipErrorHandler: true,
      ...(options || {}),
    });

    return response.data;
  } catch (error: any) {
    throw new Error(error?.info?.message || error?.message || '文件上传失败');
  }
}
